import React, { useState } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";
import Popup from "reactjs-popup"; // maybe useful component to display additional info

import { $, Foundation, moment } from "../../../../../vendor";
import { priceTariffValidFromsActions } from "inbooma-api";
import Select from "react-select";
import DropDown from "./Dropdown";
import Biscuit from "../../../../utils/Biscuit";

const PricetariffValidFromsPanel = (props) => {
  const [validFroms, setValidFroms] = useState(props.validFroms);

  const deleteValidFrom = (id) => {
    if (confirm(t("really_remove"))) {
      props.dispatch(
        priceTariffValidFromsActions.deletePricetariffValidFrom({
          id: Number(id),
          token: Biscuit.get("token"),
        }),
      );
      let filteredArray = validFroms.filter((item) => item.id !== id);
      setValidFroms(filteredArray);
    }
  };

  return (
    <div
      id={"pricetariff-panel-" + props.pricetariff.id}
      className="inb-c-item-details inb-c-pricetariff-pricetariff_valid_froms row"
    >
      <header className="inb-c-item-details__header small-12 column">
        <a
          href={"pricetariffs/" + props.pricetariff.id + "/validFrom/add"}
          className={
            "inb-c-item-add inb-pricetariff_valid_from-manage small button beautify beautify-" +
            Biscuit.get("user.client_id") +
            " float-right"
          }
          data-inb-contingent-id="<%- id %>"
          data-inb-action-link="write"
        >
          {t("add")}
        </a>
        {validFroms.length === 0 && <span className="inb-list-title">{t("no_entries")}</span>}
        {/*   {validFroms.length >= 1 &&
                <span className="inb-list-title">{t('pricetariff_valid_froms') + " (" + validFroms.length + ")"}</span>
                }*/}
      </header>
      {validFroms.length >= 1 &&
        validFroms.map((validFrom, index) => {
          return (
            <div
              className="inb-pricetariff_valid_from inb-c-item-details-row row"
              data-inb-pricetariff_valid_from-id={validFrom.id}
              data-inb-context="pricetariff_valid_froms"
            >
              <div className="column medium-10 small-10">
                <div className="row">
                  <div className="medium-3 small-12 column inb-pricetariff_valid_from__id">
                    #{validFrom.id}
                  </div>
                  <div className="medium-9 small-12 column inb-pricetariff_valid_froms__valid_from">
                    {t("valid_from_${a}", {
                      a: moment(validFrom.valid_from).format("DD.MM.YY HH:mm"),
                    })}
                  </div>
                </div>
              </div>

              <div className="medium-2 small-2 column text-right">
                <div className="row">
                  <div className="medium-8 small-6 column text-right">
                    <a
                      className="inb-pricetariff_valid_from___edit inb-c-item__edit"
                      href={"pricetariffs/" + props.pricetariff.id + "/validFrom/" + validFrom.id}
                      data-inb-action-link="edit"
                    >
                      <i className="fi fi-wrench"></i>
                    </a>
                  </div>
                  <div className="medium-4 small-6 column text-left">
                    <a
                      className="inb-pricetariff_valid_from___remove inb-c-item__remove"
                      href="#"
                      onClick={(id) => deleteValidFrom(validFrom.id)}
                      data-inb-action-link="remove"
                      title={t(" delete_${a}", { a: t("pricetariff_valid_from") })}
                    >
                      <i className="fi fi-trash"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default PricetariffValidFromsPanel;
